import './PageFooter.css';

/**
 * Page Footer Component
 * Displays the NYAFAZ logo in the footer
 */
const PageFooter = () => {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-logo-container">
          <span className="powered-by-text">Powered by</span>
          <a href="https://nyafaz.com/" aria-label="Visit NYAFAZ website">
            <img
              src={`${process.env.PUBLIC_URL}/footer.png`}
              alt="NYAFAZ logo"
              className="footer-logo"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default PageFooter;
